// extracted by mini-css-extract-plugin
export default {"baseLayout":"app_baseLayout__K+3xW","content":"app_content__mtv+1","messageIcon":"app_messageIcon__TlWdr"};